import React from "react";
import { AbsoluteModalWrapper, SettingsModal } from "../styles";
import { CloseButton } from "./CloseButton";

export interface Props {
  isOpen: boolean;
  onDismiss: () => void;
  focusRef: React.RefObject<any>;
  footer?: JSX.Element;
  body: JSX.Element;
  narrow?: boolean;
}

export const SavedSearchModal = ({
  isOpen,
  onDismiss,
  focusRef,
  footer,
  body,
  narrow = false,
}: Props) => (
  <AbsoluteModalWrapper>
    <SettingsModal
      initialFocusRef={focusRef}
      narrow={narrow}
      open={isOpen}
      right={<CloseButton close={onDismiss} />}
      onDismiss={onDismiss}
      footer={footer}
    >
      {body}
    </SettingsModal>
  </AbsoluteModalWrapper>
);
